import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mfa-enrollment-modal',
  standalone: false,
  templateUrl: './mfa-enrollment-modal.component.html',
})
export class MfaEnrollmentModalComponent {
  /** When set, shows a grace-deadline note guiding a required user to enrol. */
  @Input() daysRemaining?: number;
  /** Deadline as epoch ms, shown alongside the days-remaining note. */
  @Input() graceUntil?: number | null;
  /** Label for the dismiss button (e.g. "Remind me later" during grace). */
  @Input() dismissLabel = 'Cancel';
  /** Heading, so the same modal can also be opened to add a backup device. */
  @Input() title = 'Set up two-factor authentication';
  /** Hide the header close button when a reminder requires an explicit choice. */
  @Input() showCloseButton = true;

  completed = false;

  constructor(public activeModal: NgbActiveModal) {}

  get showDeadline(): boolean {
    return !this.completed && typeof this.daysRemaining === 'number';
  }

  onEnrolled(): void {
    this.completed = true;
  }

  close(): void {
    this.activeModal.close(this.completed);
  }
}
